// APP Settings
export const PROTOCOL = process.env.VUE_APP_PROTOCOL;
export const PORT = process.env.VUE_APP_PORT;
export const DOMAIN = process.env.VUE_APP_DOMAIN;
export const API = process.env.VUE_APP_API;
